import { customTextBlock, paragraph, button } from "../../../text/nodes"
import { SingleColumn as SingleColumnEditor } from "./single-column"
import { SingleColumnSettings } from "./single-column-settings"
import SingleColumnPreview from "./single-column-preview.png"

export const SingleColumn = {
  name: "SingleColumn",
  label: "single column",
  EditorComponent: SingleColumnEditor,
  SettingsComponent: SingleColumnSettings,
  image: SingleColumnPreview,
  defaultProperties: {
    backgroundColor: "#fafafa",
    headingColor: "#000000",
    textColor: "#4d4d4d",
    backgroundImage: "",
    horizontalPadding: 36,
    verticalPadding: 36,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#000000",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0
  },
  defaultChildren: [
    customTextBlock([
      paragraph("Our conference tickets are on sale now!", {
        alignment: "center"
      }),
      button("Learn more", { alignment: "center" })
    ])
  ]
}
